import { UserApi } from '../../generated/api';
import configuration from './configuration';

export default new UserApi(configuration);
